export default __webpack_public_path__ + "media/images/map/car/256x256-18d693e3647c865457e100338f9d1c36.png";